import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag } from '../../atoms/Tag/Tag';
import { Link } from '../../atoms/Link/Link';
import { FaqCardContainer, TagWrapper, LinkWrapper } from './FaqCard.style';
export const FaqCard = ({ type, linkText, href, inverse = false, className, }) => {
    return (_jsxs(FaqCardContainer, { "$inverse": inverse, className: className, children: [_jsx(TagWrapper, { children: _jsx(Tag, { type: "decorative", mainTag: type }) }), _jsx(LinkWrapper, { children: _jsx(Link, { href: href, inverse: inverse, size: "large", children: linkText }) })] }));
};
//# sourceMappingURL=FaqCard.js.map